import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";
const config = {
  apiKey: "AIzaSyAjLfWXUekbURBMjGRtRCDckPEqOfvXCHo",
  authDomain: "deft-cef16.firebaseapp.com",
  databaseURL: "https://deft-cef16.firebaseio.com",
  projectId: "deft-cef16",
  storageBucket: "deft-cef16.appspot.com",
  messagingSenderId: "77815690977",
  appId: "1:77815690977:web:5e06cd85a502b5ba10e9a0",
};

firebase.initializeApp(config);

export const auth = firebase.auth();

export const functions = firebase.functions();

//functions.useEmulator("localhost", 5001);

export const storage = firebase.storage();

export const fb = firebase;

export const db = firebase.firestore();
//db.useEmulator("localhost", 8080);

export const getSnapData = (snapshot) => {
  const data = snapshot.docs.map((doc) => {
    return { ...doc.data(), id: doc.id };
  });
  return data;
};
